import React from 'react';
import { Calendar, MapPin, ArrowUpRight } from 'lucide-react';

const Meta = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-2 text-[#cdd2dc] text-sm">
    <Icon className="w-4 h-4 text-[#e8743b] shrink-0" /> {children}
  </span>
);

// Card for a non-featured event (Keti Koti, Canton Fair, etc.).
const EventCard = ({ event }) => (
  <div className="dctv-card rounded-3xl overflow-hidden flex flex-col">
    <div className="relative h-56 overflow-hidden">
      <img src={event.image} alt={event.title} className="w-full h-full object-cover" />
      <span className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-[#0a0e16]/85 border border-white/10 text-[#cdd2dc] text-xs font-semibold">
        {event.scope}
      </span>
    </div>
    <div className="p-7 flex flex-col flex-1">
      <h3 className="font-serif-dctv text-2xl font-bold text-white">{event.title}</h3>
      {event.subtitle && <p className="text-[#6b7384] text-sm mt-1">{event.subtitle}</p>}
      <p className="text-[#f4965a] font-medium italic mt-2">{event.theme}</p>
      <div className="flex flex-col gap-2 mt-4">
        <Meta icon={Calendar}>{event.date}</Meta>
        <Meta icon={MapPin}>{event.venue} - {event.address}</Meta>
      </div>
      <p className="text-[#9aa3b2] text-sm leading-relaxed mt-4 flex-1">{event.intro}</p>
      <div className="space-y-3 mt-5">
        {event.info.map((it) => (
          <div key={it.title} className="border-l-2 border-[#e8743b]/40 pl-4">
            <p className="text-white text-sm font-semibold">{it.title}</p>
            <p className="text-[#9aa3b2] text-[13px] leading-relaxed mt-0.5">{it.text}</p>
          </div>
        ))}
      </div>
      <a href={event.website} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-6 text-[#e8743b] font-semibold text-sm group">
        Learn more <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </div>
  </div>
);

export default EventCard;
